import { render, staticRenderFns } from "./PianificaSidebar.vue?vue&type=template&id=74803a3a&scoped=true&"
import script from "./PianificaSidebar.vue?vue&type=script&lang=js&"
export * from "./PianificaSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PianificaSidebar.vue?vue&type=style&index=0&id=74803a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74803a3a",
  null
  
)

export default component.exports